import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";

export const Testimonials = () => (
  <section id="kundenstimmen" className="relative py-28 lg:py-40 spotlight" data-testid="testimonials-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <SectionHead eyebrow="Kundenstimmen" lines={["Was Händler", "über die Bilder sagen."]} text="Erfahrungen von Marktplatz-Händlern, Shop-Betreibern und Marken, die ihre Produkte bereits mit Salgin Solutions präsentieren." />
        </div>
        <Reveal className="lg:col-span-4 lg:pb-24 lg:text-right" delay={0.2}>
          <div className="inline-flex flex-col items-start lg:items-end gap-2" data-testid="testimonials-rating">
            <div className="flex gap-1 text-[var(--gold)]">{[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}</div>
            <p className="font-display text-3xl">5,0 <span className="text-base text-[var(--muted)]">/ 5</span></p>
            <p className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-[var(--muted-2)]">Durchschnittliche Bewertung</p>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`card-glass p-8 lg:p-9 flex flex-col hover:border-[var(--line-strong)] transition-colors duration-500 ${i === 0 ? "lg:row-span-2" : ""}`}
            data-testid={`testimonial-card-${i}`}
          >
            <div className="flex items-center justify-between">
              <Quote size={22} className="text-[var(--gold)]" />
              <div className="flex gap-0.5 text-[var(--gold)]">{[...Array(t.stars)].map((_, k) => <Star key={k} size={12} fill="currentColor" />)}</div>
            </div>
            <blockquote className={`mt-6 font-display leading-snug text-[var(--text)] flex-1 ${i === 0 ? "text-2xl lg:text-[1.9rem]" : "text-xl"}`}>
              „{t.quote}“
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-[var(--line)] flex items-center gap-4">
              <span className="w-11 h-11 shrink-0 border border-[var(--line-strong)] flex items-center justify-center font-display text-lg text-[var(--gold)]">{t.initials}</span>
              <div>
                <p className="text-sm font-semibold">{t.name}</p>
                <p className="text-xs text-[var(--muted)] mt-0.5">{t.role}</p>
              </div>
              <span className="ml-auto font-mono text-[0.55rem] tracking-[0.2em] uppercase text-[var(--gold)] border border-[var(--line)] px-2 py-1">{t.platform}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
